/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { BuildingAmenity, ListingAmenity, getEnumTitle } from '@zcode/enums'
import type { Filters } from '@zcode/state-type'

export const mapAmenities = (
  listingAmenities: Filters['listingAmenities'] = [],
  buildingAmenities: Filters['buildingAmenities'] = []
) => {
  const amenities: string[] = []

  for (const amenityId of listingAmenities) {
    if (typeof amenityId === 'number') {
      amenities.push(getEnumTitle(ListingAmenity, amenityId))
    }
  }
  for (const amenityId of buildingAmenities) {
    if (typeof amenityId === 'number') {
      amenities.push(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `${getEnumTitle(BuildingAmenity, amenityId)}${
          amenityId === BuildingAmenity.ON_SITE_LAUNDRY ? ' - Building' : ''
        }`
      )
    }
  }

  return amenities
}
